module.exports = __webpack_public_path__ + "static/media/zoom-fit.81cad89a.svg";